module.exports = __webpack_public_path__ + "img/sesame.918f5dcb.svg";